import React, { useState } from "react";
import { Link } from "react-router-dom";
import BottomSheet from "../../bottom-sheet/bottom-sheet";
import BottomSheet2 from "../../buttom-page/bottom-page";
import EditKilometer from "./edit-kilometer";
import styles from "./CardSingleTop.module.css";
import { FaMoneyBillWave } from "react-icons/fa";
import { MdBuild, MdOutlineCalendarMonth } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";

const CardSingleTop = ({ car }) => {
    const [isOpenEditKilometer, setIsOpenEditKilometer] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);

    const imageSrc = car?.imageUrl || "/default-avatar.png";

    const formatPrice = (price = 0) => {
        if (price >= 1000000)
            return `${(price / 1000000).toFixed(1)}M`;
        if (price >= 1000)
            return `${(price / 1000).toFixed(0)}K`;
        return price;
    };

    const daysFromLastService =
        car?.daysFromLastService !== undefined &&
        car?.daysFromLastService !== null &&
        car?.daysFromLastService !== -1
            ? car.daysFromLastService
            : "-";

    const kilometer =
        car?.kilometer !== undefined && car?.kilometer !== null
            ? car.kilometer.toLocaleString()
            : "-";

    return (
        <>
            <article className={styles.card} dir="rtl">
                {/* ===== Header : Menu | Info | Image ===== */}
                <div className={styles.header}>
                    {/* تصویر خودرو - سمت چپ */}
                    <div className={styles.imageWrapper}>
                        <img
                            src={imageSrc}
                            alt={car?.title || "خودرو"}
                            className={styles.carImage}
                        />
                    </div>

                    {/* نام + کیلومتر */}
                    <div className={styles.infoWrapper}>
                        <h2 className={styles.title}>
                            {car?.title || "-"}
                        </h2>

                        <div className={styles.kmRow}>
                            <span className={styles.kmIcon}>🚗</span>
                            <span className={styles.kmValue}>
                                {kilometer} km
                            </span>

                            <button
                                type="button"
                                className={styles.editKmBtn}
                                onClick={() =>
                                    setIsOpenEditKilometer(true)
                                }
                                aria-label="ویرایش کیلومتر"
                            >
                                ✏️
                            </button>
                        </div>
                    </div>

                    {/* دکمه منو */}
                    <button
                        type="button"
                        className={styles.menuBtn}
                        onClick={() => setOpenMenu(true)}
                        aria-label="منو"
                    >
                        <BsThreeDotsVertical />
                    </button>
                </div>

                {/* ===== KPI Row (3 columns, مثل عکس) ===== */}
                <section className={styles.kpiBar}>
                    <div className={styles.kpiItem}>
                        <FaMoneyBillWave
                            className={`${styles.kpiIcon} ${styles.money}`}
                        />
                        <span className={styles.kpiLabel}>
                            هزینه کل
                        </span>
                        <strong className={styles.kpiValue}>
                            {formatPrice(car?.totalCost || 0)}
                        </strong>
                    </div>

                    <div className={styles.kpiDivider} />

                    <div className={styles.kpiItem}>
                        <MdBuild
                            className={`${styles.kpiIcon} ${styles.service}`}
                        />
                        <span className={styles.kpiLabel}>
                            تعداد سرویس
                        </span>
                        <strong className={styles.kpiValue}>
                            {car?.servicesCount || 0}
                        </strong>
                    </div>

                    <div className={styles.kpiDivider} />

                    <div className={styles.kpiItem}>
                        <MdOutlineCalendarMonth
                            className={`${styles.kpiIcon} ${styles.calendar}`}
                        />
                        <span className={styles.kpiLabel}>
                            روز از آخرین سرویس
                        </span>
                        <strong className={styles.kpiValue}>
                            {daysFromLastService}
                        </strong>
                    </div>
                </section>
            </article>

            {/* ===== BottomSheets ===== */}
            <BottomSheet
                isOpen={isOpenEditKilometer}
                onClose={() => setIsOpenEditKilometer(false)}
                snapPoint="250"
            >
                <EditKilometer
                    car={car}
                    closeButtomSheetHandler={() =>
                        setIsOpenEditKilometer(false)
                    }
                />
            </BottomSheet>

            <BottomSheet2
                isOpen={openMenu}
                onClose={() => setOpenMenu(false)}
            >
                <div className={styles.sheetTitle}>
                    <div>🚗 {car?.title}</div>
                    <small>مدل {car?.productYear}</small>
                </div>

                <Link
                    className={styles.sheetAction}
                    to="/reports"
                    state={{ carId: car?.id }}
                    onClick={() => setOpenMenu(false)}
                >
                    <span>📊</span>
                    <span>گزارش و نمودار</span>
                </Link>

                <Link
                    className={styles.sheetAction}
                    to="/all-expense"
                    state={{ carId: car?.id }}
                    onClick={() => setOpenMenu(false)}
                >
                    <span>💰</span>
                    <span>هزینه ها</span>
                </Link>

                <button
                    className={styles.cancelBtn}
                    onClick={() => setOpenMenu(false)}
                >
                    انصراف
                </button>
            </BottomSheet2>
        </>
    );
};

export default CardSingleTop;